module.exports = __webpack_public_path__ + "img/1493244826.9859856e.jpg";